import { P2GText } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { CentimetreAbbreviation } from '~/components/MeasurementUnits/MeasurementUnit';
import { Dimensions } from '~/lib/api/smartsend/types';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  dimensions: Dimensions;
  variant?: 'h4' | 'h5' | 'h6' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2' | 'button';
  colour?: 'initial' | 'inherit' | 'primary' | 'secondary' | 'textPrimary' | 'textSecondary' | 'error';
}

export function DimensionAndWeightDisplay(props: props) {
  const { t } = useTranslation([TranslationNamespaces.SMARTSEND, TranslationNamespaces.COMMON]);
  if (
    !props.dimensions ||
    (!props.dimensions.Height && !props.dimensions.Width && !props.dimensions.Length && !props.dimensions.Weight)
  ) {
    return null;
  }

  return (
    <P2GText variant={props.variant} colour={props.colour}>
      {props.dimensions.Weight > 0 && <>{props.dimensions.Weight}kg</>}
      {props.dimensions.Length > 0 && props.dimensions.Width > 0 && props.dimensions.Height > 0 && (
        <>
          {props.dimensions.Weight > 0 && <>&nbsp;&nbsp;|&nbsp;&nbsp;</>}
          <P2GText variant={props.variant} small>
            {DimensionDisplay(props.dimensions)}&nbsp;{t(CentimetreAbbreviation.key, CentimetreAbbreviation.options)}
          </P2GText>
        </>
      )}
    </P2GText>
  );
}

export function DimensionDisplay(props: Dimensions) {
  if (props.Length && props.Width && props.Height) {
    return `${props.Length} x ${props.Width} x ${props.Height}`;
  }
  return null;
}
